export default "__VITE_ASSET__C$i3Lfxr__"